import { render } from "./AdvertisingMaterial.vue?vue&type=template&id=6dfea3a7&scoped=true"
import script from "./AdvertisingMaterial.vue?vue&type=script&lang=js"
export * from "./AdvertisingMaterial.vue?vue&type=script&lang=js"

import "./AdvertisingMaterial.vue?vue&type=style&index=0&id=6dfea3a7&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfea3a7"]])

export default __exports__